import React from 'react';
import { NavLink, useHistory, useParams } from 'react-router-dom';
import DefaultLayout from '../../shared/layout/DefaultLayout';
import PhotoGrid from './PhotoGrid';
import { formatD, getBreadcrumbArray, getCategoryBrowserUrl, getUserAvatarImageUrl, handlePrice, translateState } from '../../shared/util/MiscUtil';
import { useGlobalContext } from '../../shared/state/GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '../../shared/components/basic/Button';
import ListingGridBox from './ListingGridBox';
import api from '../../shared/client/api';
import noAvatar from '../../assets/images/no-avatar.jpg';
import Input from '../../shared/components/basic/Input';
import Rating from '../../shared/components/Rating';
import Textarea from '../../shared/components/basic/Textarea';
import { useToastContext } from '../../shared/state/ToastContext';
import { useAuthContext } from '../../shared/auth/AuthContext';
import { useMediaQuery } from 'react-responsive'
import { IconsLibrary } from "../../shared/util/FontAwesomeIconsUtil";
import Label from '../../shared/components/basic/Label';
import FieldError from '../../shared/components/basic/FieldError';
import { FacebookShareButton, PinterestShareButton, TwitterShareButton } from 'react-share';
import ViewListingSEO from '../../shared/components/seo/ViewListingSEO';
import isEmpty from 'lodash.isempty';
import orderBy from 'lodash.orderby';
import isInteger from 'lodash.isinteger';
import Select from '../../shared/components/basic/Select';
import { gaEvents } from '../../shared/hooks/events';
import MapLayoutView from '../../shared/components/maps/MapLayoutView';
import { decryptResponseData } from '../../shared/util/CryptoDecryptionUtil';

function Breadcrumb({ breadcrumb, listing, ...rest }) {

    const linkClasses = "text-gray-darkest hover:underline";

    return (
        <div className="flex flex-wrap w-full py-6" {...rest}>
            <NavLink className={linkClasses} to="/" title="Početna">Početna</NavLink>
            {breadcrumb.map((crumb, index) => {
                return (
                    <div className="flex flex-nowrap items-center justify-start" key={index}>
                        <FontAwesomeIcon icon={IconsLibrary.faChevronRight} className="text-sm text-yellow mx-3" />
                        {!!crumb && !!crumb.root && (<span className="text-gray-darkest">{crumb.name}</span>)}
                        {!!crumb && crumb.root === false && (<NavLink className={linkClasses} to={getCategoryBrowserUrl(crumb.id, crumb.slug)} title={crumb.name}>{crumb.name}</NavLink>)}
                        {!crumb && (<span className={linkClasses}>...</span>)}
                    </div>
                );
            })}
            {!!listing && (
                <div className="flex flex-nowrap items-center justify-start">
                    <FontAwesomeIcon icon={IconsLibrary.faChevronRight} className="text-sm text-yellow mx-3" />
                    <span className="text-gray">Oglas #{listing.id}</span>
                </div>
            )}
        </div>
    );
}

function ListingOwnerCard({ owner, ...rest }) {

    const [avatarFallbackImage, setAvatarFallBackImage] = React.useState(false);

    const activeListingsText = activeListings => {
        let text = "";

        if (Number(activeListings) === 0) {
            text = "Nema aktivnih oglasa";
        } else if (Number(activeListings) === 1) {
            text = "1 aktivan oglas";
        } else if (activeListings > 1 && activeListings < 5) {
            text = activeListings + " aktivna oglasa";
        } else if (activeListings > 4 && activeListings < 21) {
            text = activeListings + " aktivnih oglasa";
        } else if (Number(String(activeListings).slice(-1)) === 1) {
            text = activeListings + " aktivan oglas";
        } else if (Number(String(activeListings).slice(-1)) > 1 && Number(String(activeListings).slice(-1)) < 5) {
            text = activeListings + " aktivna oglasa";
        } else {
            text = activeListings + " aktivnih oglasa";
        }

        return text;
    }

    const handleListingOwnerLocation = (owner) => {
        if (!!owner.location.city && !owner.location.zipName) {
            return <span>{owner.location.city}</span>;
        } else if (!!owner.location.city && !!owner.location.zipName && owner.location.city.toLowerCase() === owner.location.zipName.toLowerCase()) {
            return <span>{owner.location.zipName}</span>;
        } else if (!!owner.location.city && !!owner.location.zipName && owner.location.city.toLowerCase() !== owner.location.zipName.toLowerCase()) {
            return <span>{owner.location.zipName + ", " + owner.location.city}</span>;
        } else {
            return <span>{owner.location.zipName}</span>;
        }
    };

    return (
        <>
            {!!owner && (
                <NavLink
                    className="w-full flex flex-wrap justify-between p-3 rounded-lg bg-white border-1 border-white hover:border-gray-lighter transition"
                    to={"/profil/" + owner.login}
                    title={!!owner.companyName ? owner.companyName + " (" + owner.login + ")" : owner.login}
                    {...rest}
                >
                    <div className="justify-center md:justify-start flex flex-nowrap mb-2 md:mb-0 w-full md:w-1/2">
                        {/* owner avatar */}
                        {!!owner.companyAccount ? (
                            <div 
                            className="flex items-center justify-center w-24 h-24 object-cover object-center overflow-hidden rounded-full border-1 border-gray-lighter bg-gray-light">
                                <img 
                                onError={(error) => {
                                    if (!!error) {
                                        setAvatarFallBackImage(true);
                                    } else setAvatarFallBackImage(false);
                                }}
                                className={`${!!avatarFallbackImage ? `object-fill` : `object-cover` } object-center`} alt={owner.login} src={!!avatarFallbackImage ? noAvatar : getUserAvatarImageUrl(owner)} width={94} height={94} />
                            </div>
                        ) : (
                            <div className="flex items-center justify-center w-24 h-24 object-cover object-center overflow-hidden rounded-full border-1 border-gray-lighter bg-gray-light">
                                <img 
                                onError={(error) => {
                                    if (!!error) {
                                        setAvatarFallBackImage(true);
                                    } else setAvatarFallBackImage(false);
                                }}
                                className={`${!!avatarFallbackImage ? `object-fill` : `object-cover` } object-center`} alt={owner.login} src={!!avatarFallbackImage ? noAvatar : getUserAvatarImageUrl(owner)} width={94} height={94} />
                            </div>
                        )}

                        {/* owner details */}
                        <div className={!!owner.grade ? 'flex flex-col justify-between py-1.5 px-2 mx-2' : 'flex flex-col py-1.5 px-2 mx-2'}>
                            <div className="mb-1">
                                <div>
                                    {/* owner name */}
                                    {owner.companyAccount ? (
                                        <div className="flex flex-row space-x-2">
                                            {!!owner.companyName && (<span className="font-bold text-gray-darker">{owner.companyName}</span>)}
                                            {!!owner.phoneVerified && !!owner.locationVerified && <FontAwesomeIcon icon={IconsLibrary.faCheckCircle} className="text-purple self-center" />}
                                        </div>
                                    ) : (
                                        <div className="flex flex-row space-x-2">
                                            {!!owner.firstName && !!owner.lastName && (<span className="font-bold text-gray-darker">{owner.firstName + " " + owner.lastName}</span>)}
                                            {(!owner.firstName || !owner.lastName) && (<span className="font-bold text-gray-darker">{owner.login}</span>)}
                                            {!!owner.phoneVerified && !!owner.locationVerified && <FontAwesomeIcon icon={IconsLibrary.faCheckCircle} className="text-purple self-center" />}
                                        </div>
                                    )}
                                </div>
                                <div className="flex flex-nowrap items-center justify-start text-gray-darkest my-1">
                                    <Rating reviews={owner.reviews} grade={owner.grade} />
                                </div>
                            </div>
                            <div className="font-semibold text-sm text-purple">{activeListingsText(owner.activeListings)}</div>
                        </div>
                    </div>

                    {/* contact details actions */}
                    <div className="flex flex-col w-full md:w-1/2 justify-between py-1.5 pr-2">
                        {!!owner.companyAccount && (
                            <div className="text-center md:text-right text-sm mb-2">
                                <FontAwesomeIcon icon={IconsLibrary.faStore} className="text-xl text-purple mr-2" />
                                <span className="font-bold text-gray-darker">Radnja</span>
                            </div>
                        )}
                        {!owner.companyAccount && (
                            <div className="text-center md:text-right text-sm mb-2">
                                <FontAwesomeIcon icon={IconsLibrary.faUser} className="text-xl text-purple mr-2" />
                                <span className="font-bold text-gray-darker">Korisnik</span>
                            </div>
                        )}
                        {!!owner.location && (
                            <div className="text-center md:text-right text-sm text-gray-darker font-semibold">
                                <FontAwesomeIcon icon={IconsLibrary.faMapMarker} className="mr-2" />
                                {handleListingOwnerLocation(owner)}
                            </div>
                        )}
                    </div>
                </NavLink>
            )}
        </>
    );
}

function AttributeBox({ attribute }) {
    let value = "";

    switch (attribute.definition.type) {
        case "INTEGER":
        case "DECIMAL":
        case "STRING":
        case "YEAR":
            value = attribute.value;
            break;
        case "OPTIONS":
            value = !!attribute.definition.meta[attribute.value] ? attribute.definition.meta[attribute.value] : "/";
            break;
        case "BOOLEAN":
            value = !!attribute.value && attribute.value === "true" ? "Da" : "Ne";
            break;
        default:
            value = attribute.value;
    }

    if (!!attribute.definition.prefix) {
        value = attribute.definition.prefix + " " + value;
    }

    if (!!attribute.definition.suffix) {
        value = value + " " + attribute.definition.suffix;
    }

    return (
        <div className="flex flex-nowrap items-center justify-between py-2 px-3 rounded bg-white text-gray-darkest">
            <span className="font-semibold">{attribute.definition.name.trim()}:</span>
            <span className="font-base">{value}</span>
        </div>
    );
}

function ViewListing(props) {

    const { notify, setContextStyleColor } = useToastContext();
    const { auth } = useAuthContext();
    const url = props.match.url;

    const { listingId } = useParams();
    const [listing, setListing] = React.useState(null);
    const [readMore, setReadMore] = React.useState(false);
    const [moreInfo, setMoreInfo] = React.useState(false);
    const [addToCartLoading, setAddToCartLoading] = React.useState(false);
    const [addToCartError, setAddToCartError] = React.useState(null);
    const [addToCartQty, setAddToCartQty] = React.useState(1);
    const [similarListings, setSimilarListings] = React.useState([]);
    const [newestCategory, setNewestCategory] = React.useState([]);
    const [newestLister, setNewestLister] = React.useState([]);
    const [favoriteLoading, setFavoriteLoading] = React.useState(false);
    const [finishLoading, setFinishLoading] = React.useState(false);
    const [loaded, setIsLoaded] = React.useState(false);
    const [canFav, setCanFav] = React.useState(false);
    const [phoneButton, setPhoneButton] = React.useState("Telefon");
    // const [messageLoading, setMessageLoading] = React.useState(false);
    const [createOrderRequest, setCreateOrderRequest] = React.useState(false);
    const [userBlocked, setUserBlocked] = React.useState(false);
    const title = !!listing && listing.title;
    const [showReportModal, setShowReportModal] = React.useState(false);
    const [reportReasonSending, setReportReasonSending] = React.useState(false);
    const [reportReasonSendingError, setReportReasonSendingError] = React.useState(null);
    const [reportReasonSentSuccess, setReportReasonSentSuccess] = React.useState(false);
    const [reportReasonMessage, setReportReasonMessage] = React.useState("");
    const [reportReasonValidationErrors, setReportReasonValidationErrors] = React.useState([]);
    const [selectedVariation, setSelectedVariation] = React.useState("");
    const [variationAddedToCart, setVariationAddedToCart] = React.useState(false);

    const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 1280px)' })
    // const isTablet = useMediaQuery({ query: '(min-width: 680px and max-width: 1280px)' })
    // const isMobile = useMediaQuery({ query: '(max-width: 450px)' })

    const history = useHistory();

    const handleMessage = () => {
        if (!listing) {
            return;
        }
        if (!!userBlocked) {
            notify({
                text: "Korisnik Vas je blokirao.",
                id: "user-blocked-notification-message",
              });
              setContextStyleColor('bg-red');
              return;
        }
        // setMessageLoading(true);
        api.post("/conversations", {
            listingId: listingId
        })
            .then(response => response.data)
            .then(response => {
                // setMessageLoading(false);
                history.push("/poruke/" + response.data.id)
            })
            .catch(error => {
                // setMessageLoading(false);
            })
    }

    const validateReasonMessage = () => {
        let errors = [];

        if (reportReasonMessage.length < 10) {
            errors.push({
                field: "report-reason",
                message: "Razlog prijave mora biti popunjen i ne kraći od 10 karaktera."
            });
        }

        return errors;
    }

    const handleOpenReportModal = () => {
        // if (!!auth.isAuthenticated && !!userBlocked) {
        //     notify({
        //         text: "Korisnik Vas je blokirao.",
        //         id: "user-blocked-notification-view-listing",
        //       });
        //       setContextStyleColor('bg-red');
        //     return;
        // }
        if (!!auth.isAuthenticated && !!auth.currentUser && auth.currentUser.id === listing.owner.id) {
            notify({
                text: "Nije moguće prijaviti vlastiti oglas!",
                id: "user-cannot-report-to-self-notification-view-listing",
              });
              setContextStyleColor('bg-red');
              return;
        }
        setShowReportModal(true);
    }


    const handleSendReport = () => {
        const errors = validateReasonMessage();

        if (errors.length > 0) {
            setReportReasonValidationErrors(errors);
        } else {
            setReportReasonValidationErrors([]);
            setReportReasonSending(true);
            api.post("/moderation-requests", {
                listingId: listing.id,
                reason: reportReasonMessage
            })
            .then(response => response.data)
            .then(response => {
                if (!!response && response.startsWith("Listing reported successfully")) {
                    setReportReasonSentSuccess(true);
                    setTimeout(() => {
                        handleDiscardReport();
                    }, 2000);
                } else {
                    setReportReasonSentSuccess(false);
                }

            })
            .catch(error => {
                setReportReasonSentSuccess(false);
                setReportReasonSending(false);
                setReportReasonSendingError("Desila se greška prilikom slanja prijave. Pokušajte ponovo kasnije.")
            })
        }
    }

    const handleDiscardReport = () => {
        setReportReasonMessage("");
        setShowReportModal(false);
        setReportReasonValidationErrors([]);
        setReportReasonSending(false);
        setReportReasonSendingError(null);
        setReportReasonSentSuccess(false);
    }

    const handleCreateOrder = () => {
        if (!listing) {
            return;
        }
        if (!!userBlocked) {
            notify({
                text: "Korisnik Vas je blokirao.",
                id: "user-blocked-notification-message",
              });
              setContextStyleColor('bg-red');
              return;
        }
        setCreateOrderRequest(true);
    }

    const handleCreateOrderRequest = () => {
        if (!listing) {
            return;
        }
        if (!!userBlocked) {
            notify({
                text: "Korisnik Vas je blokirao.",
                id: "user-blocked-notification-message",
              });
              setContextStyleColor('bg-red');
              return;
        }
        const create = {
            sellerId: listing.owner.id,
            lineItem: {
                listingId: listing.id,
                //quantity: 1
            }
        };

        if (!!listing.variations && listing.variations.length !== 0) {
            const extractVariation = listing.variations.find(v => v.id === parseInt(selectedVariation));
            if (!!selectedVariation) {
                const createForVariation = {
                    sellerId: listing.owner.id,
                    lineItem: {
                        listingId: listing.id,
                        variationId: extractVariation.id,
                        variationTitle: extractVariation.title
                    }
            };

            api.post("/orders/simple", createForVariation)
            .then(response => response.data)
            .then(response => {
                gaEvents.simpleOrderEvent("Direktna kupovina oglasa sa varijacijom", `Korisnik ${auth.currentUser.login} je poslao zahtjev za kupovinu oglasa ${listing.title + " - " + extractVariation.title} od vlasnika ${listing.owner.id}`);
                setCreateOrderRequest(false);
                notify({
                    text: "Uspješno ste poslali zahtjev za kupovinu",
                    id: "create-simple-order-success-variation"
                });
                setContextStyleColor("bg-purple");
                history.push("/kupovine/");
            })
            .catch(error => {
                setCreateOrderRequest(false);
                if (error.response.status === 401) {
                    notify({
                        text: "Već imate kreiranu narudžbu za ovaj oglas.",
                        id: "create-simple-order-variation-3"
                    });
                    setContextStyleColor("bg-red");
                } else {
                    notify({
                        text: "Greška! Neuspješna kupovina, molimo Vas pokušajte kasnije.",
                        id: "create-simple-order-fail-variation-2"
                    });
                    setContextStyleColor("bg-red");
                }
              });
            } else {
                setContextStyleColor("bg-red");
                notify({
                    text: "Odaberite varijaciju!",
                    id: "create-simple-order-fail-variation"
                });
            }
        } else {
            api.post("/orders/simple", create)
            .then(response => response.data)
            .then(response => {
                gaEvents.simpleOrderEvent("Direktna kupovina oglasa", `Korisnik ${auth.currentUser.login} je poslao zahtjev za kupovinu oglasa ${listing.title} od vlasnika ${listing.owner.id}`);
                setCreateOrderRequest(false);
                notify({
                    text: "Uspješno ste poslali zahtjev za kupovinu",
                    id: "create-simple-order-success"
                });
                setContextStyleColor("bg-purple");
                history.push("/kupovine/");
            })
            .catch(error => {
                setCreateOrderRequest(false);
                if (error.response.status === 401) {
                    notify({
                        text: "Već imate kreiranu narudžbu za ovaj oglas.",
                        id: "create-simple-order-fail-2"
                    });
                    setContextStyleColor("bg-red");
                } else {
                    notify({
                        text: "Greška! Neuspješna kupovina, molimo Vas pokušajte kasnije.",
                        id: "create-simple-order-fail"
                    });
                    setContextStyleColor("bg-red");
                }
            });
        }
    }

    const handleFavorite = () => {
        if (!listing) {
            return;
        }
        setFavoriteLoading(true);
        api
            .post("/favorites", {
                listingId: listing.id,
            })
            .then(response => {
                notify({
                    text: "Dodali ste \"" + listing.title + "\" u favorite!",
                    id: "favorite-successful"
                });
                setContextStyleColor("bg-purple");
                setFavoriteLoading(false);
                api
                    .get("/favorites/" + listingId)
                    .then(response => response.data)
                    .then(response => {
                        if (isMounted.current) {
                            if (!!response && response.length !== 0) {
                                setCanFav(false);
                            } else {
                                setCanFav(true);
                            }
                        }
                    })
                    .catch(error => {
                    });
            })
            .catch(error => {
                if (error.response.status === 401) {
                    notify({
                        text: "Već imate 500 favorita. Nije moguće sačuvati više.",
                        id: "favorite-limit-exceeded"
                    });
                    setContextStyleColor("bg-red");
                }
                notify({
                    text: "Nažalost, desila se neočekivana greška. Pokušajte ponovo kasnije.",
                    id: "favorite-error"
                });
                setContextStyleColor("bg-red");
                setFavoriteLoading(false);
            })
    }

    const handleFinish = id => {
        setFinishLoading(true);
        api.post("/listings/" + id + "/finish")
            .then(response => {
                setFinishLoading(false);
                notify({
                    text: "Završili ste oglas uspješno.",
                    id: "finished-view-listing-success"
                });
                setContextStyleColor("bg-purple");
                history.push("/moji-oglasi?status=HIDDEN")
            })
            .catch(error => {
                setFinishLoading(false);
                notify({
                    text: "Desila se neočekivana greška. Pokušajte ponovo kasnije.",
                    id: "finished-view-listing-error"
                });
                setContextStyleColor("bg-red");
            });
    }

    const validateVariationQuantity = () => {
        if (!!listing && !!listing.variations && listing.variations.length !== 0) {
            if (!!selectedVariation && selectedVariation.length !== 0) {
                const findQuantityforChoosenVariation = listing.variations.find((v) => v.id === parseInt(selectedVariation));
                if (!!findQuantityforChoosenVariation) {
                    return findQuantityforChoosenVariation.quantityOnStock;
                } else return null;
            } else return null;
        } else return null;
    };

    const handleAddToCartQty = event => {
        const qty = event.target.value;
        if (!isInteger(qty) || parseInt(qty) < 0) {
            return;
        } else if (!!validateVariationQuantity()) {
            const quantity = validateVariationQuantity();
            if (parseInt(quantity) < parseInt(qty)) {
                setAddToCartQty(1);
                setAddToCartError("Nije moguće dodati traženu količinu u korpu.");
                return;
            };
        } else if (parseInt(listing.quantityOnStock) < parseInt(qty)) {
            setAddToCartQty(1);
            setAddToCartError("Nije moguće dodati traženu količinu u korpu.");
            return;
        } else {
            setAddToCartQty(qty);
        }
    }

    const incrementAddToCartQty = () => {
        if (!!listing) {
            if ((!!listing && !!listing.variations) && (Array.isArray(listing.variations) && listing.variations.length !== 0) && selectedVariation.length === 0) {
                setContextStyleColor("bg-red");
                notify({
                    text: "Odaberite varijaciju kako biste mogli povećavati količinu.",
                    id: "cannot-increment-with-no-selected-variation"
                });
            } else if (!!validateVariationQuantity()) {
                const quantity = validateVariationQuantity();
                if (parseInt(quantity) < parseInt(addToCartQty)) {
                    setAddToCartQty(quantity);
                    setAddToCartError("U korpu je dodata količina dostupna na stanju.");
                    return;
                }
                if (parseInt(quantity) < parseInt(addToCartQty) + 1) {
                    setAddToCartError("Nije moguće dodati veću količinu u korpu.");
                    return;
                }
                setAddToCartError(null);
                setAddToCartQty(parseInt(addToCartQty) + 1);
            } else {
                if (parseInt(listing.quantityOnStock) < parseInt(addToCartQty)) {
                    setAddToCartQty(listing.quantityOnStock);
                    setAddToCartError("U korpu je dodata količina dostupna na stanju.");
                    return;
                }
                if (parseInt(listing.quantityOnStock) < parseInt(addToCartQty) + 1) {
                    setAddToCartError("Nije moguće dodati veću količinu u korpu.");
                    return;
                }
                setAddToCartError(null);
                setAddToCartQty(parseInt(addToCartQty) + 1);
            }
        }
    }

    const decrementAddToCartQty = () => {
        const newQty = parseInt(addToCartQty) - 1;
        if (newQty > 0) {
            setAddToCartError(null);
            setAddToCartQty(newQty);
        }
    }

    const { categories, addToCart, addToCartVariation } = useGlobalContext();
    const isMounted = React.useRef(true);

    React.useEffect(() => {
        isMounted.current = true;
        api.get("/listings/web/" + listingId)
            .then(response => {
                if (!!isMounted.current) {
                    const decryptedListings = decryptResponseData(response.data);
                    if (!!JSON.parse(decryptedListings).data) {
                        setListing(JSON.parse(decryptedListings).data);
                        setIsLoaded(true);
                    }
                }
            })
            .catch(error => { });

        return () => {
            isMounted.current = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const currentCategory = !!listing && listing.category;

    React.useEffect(() => {
        isMounted.current = true;

        if (!!currentCategory && !!listing) {
            api.post("/collect/numbers", { listingId: listingId })
                .then(response => { })
                .catch(error => { });
        }

        if (!!auth && !!auth.currentUser && !!listing) {
            api.get("/blocked/users/" + auth.currentUser.id)
                .then(response => response.data)
                .then(response => {
                        if (!!response && response.length !== 0) {
                            const findByCurrentBlockerUser = response.find((blockerUser) => blockerUser.blockerUserId === listing.owner.id &&
                            blockerUser.blockedUserId === auth.currentUser.id);
                            if (!!findByCurrentBlockerUser && !isEmpty(findByCurrentBlockerUser)) {
                                if (!!isMounted.current) {
                                    setUserBlocked(true);
                                }
                            } else {
                                if (!!isMounted.current) {
                                    setUserBlocked(false);
                                }
                            }
                        }
                })
                .catch(error => {});
        }

        return () => {
            isMounted.current = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listing]);

    React.useEffect(() => {
        isMounted.current = true;

        if (!!currentCategory && !!listing) {
            api.get("/listings/category/web/" + currentCategory.id + "/newest")
                .then(response => {
                    if (!!isMounted.current) {
                        const decryptedListings = decryptResponseData(response.data);
                        if (!!JSON.parse(decryptedListings).data) {
                            setNewestCategory(JSON.parse(decryptedListings).data);
                        }
                    }
                })
                .catch(error => { });
        }

        return () => {
            isMounted.current = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listing]);

    React.useEffect(() => {
        isMounted.current = true;

        if (!!listing) {
            api.get("/listings/users/web/" + listing.owner.id + "/newest")
                .then(response => {
                    if (!!isMounted.current) {
                        const decryptedListings = decryptResponseData(response.data);
                        if (!!JSON.parse(decryptedListings).data) {
                            setNewestLister(JSON.parse(decryptedListings).data);
                        }
                    }
                })
                .catch(error => { });
        }

        return () => {
            isMounted.current = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listing]);

    React.useEffect(() => {
        if (!!variationAddedToCart && !!selectedVariation) {
            setVariationAddedToCart(false);
            setSelectedVariation("");
            setAddToCartError(null);
            setAddToCartLoading(true);
            const extractVariation = listing.variations.find(v => v.id === parseInt(selectedVariation));
            const items = [
                {
                    item_id: selectedVariation,
                    item_name: listing.title + " - " + extractVariation.title,
                    currency: "BAM",
                    discount: !!listing.discountActive ? listing.price : 0,
                    item_brand: !!listing.brand ? listing.brand.name : "",
                    item_category: !!listing.category ? listing.category.name : "",
                    item_variant: extractVariation.title,
                    price: listing.price,
                    quantity: addToCartQty
                }
            ];
            
            gaEvents.addToCartEvent(listing.price, items);
            addToCartVariation(
                listing,
                addToCartQty,
                selectedVariation,
                // callback
                () => {
                    setAddToCartLoading(false);
                    setAddToCartQty(1);
                    if (addToCartError === null) {
                        setContextStyleColor('bg-purple');
                        notify({
                            text: "Varijacija dodana u korpu uspješno!",
                            id: "add-to-cart-success-view-listing-with-variation",
                        });
                        localStorage.setItem("cart_buyer_initiate", !!auth && !!auth.currentUser && auth.currentUser.id);
                    }
                },
                // error callback
                error => { setAddToCartError(error) }
                ) 
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [variationAddedToCart])

    React.useEffect(() => {
        isMounted.current = true;

        if (!!listing) {
            api.get("/listings/similar/web/" + listingId)
                .then(response => {
                    if (!!isMounted.current) {
                        const decryptedListings = decryptResponseData(response.data);
                        if (!!JSON.parse(decryptedListings).data) {
                            setSimilarListings(JSON.parse(decryptedListings).data);
                        }
                    }
                })
                .catch(error => { });
        }

        return () => {
            isMounted.current = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listing]);

    React.useEffect(() => {
        isMounted.current = true;
        if (!!auth.isAuthenticated && !!listing) {
            api
                .get("/favorites/" + listingId)
                .then(response => response.data)
                .then(response => {
                    if (isMounted.current) {
                        if (!!response && response.length !== 0) {
                            setCanFav(false);
                        } else {
                            setCanFav(true);
                        }
                    }
                })
                .catch(error => {
                });
        }
        return () => {
            isMounted.current = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth, listing]);

    const breadcrumb = !!currentCategory && !!categories ? getBreadcrumbArray(categories, currentCategory) : [];
    const readMoreIcon = !readMore ? IconsLibrary.faChevronDown : IconsLibrary.faChevronUp;
    const moreInfoIcon = !moreInfo ? IconsLibrary.faChevronDown : IconsLibrary.faChevronUp;

    const attributes = !!listing && !!listing.attributes && listing.attributes.length > 0 ? listing.attributes : [];

    const starredAttributes = orderBy(attributes.filter(attribute => attribute.definition.starred), ["definition.weight"], ["asc"]);
    const unstarredAttributes = orderBy(attributes.filter(attribute => !attribute.definition.starred), ["definition.weight"], ["asc"]);

    const descriptionClean = !!listing && !!listing.description && listing.description.replace(/(<([^>]+)>|(&#xfeff;))/gi, " ").trim();
    const descriptionExcerpt = !!listing && !!listing.description && listing.description.substring(0, 120).trim();

    const handleVariationSelectOptions = () => {
        if (!!listing && !!listing.variations && listing.variations.length !== 0) {
            const grouped = [];
            listing.variations.forEach((v) => grouped.push({
                id: v.id,
                name: v.title
            }));
            return grouped;
        } else return null;
    };

    const handleVariationChange = (event) => {
        setAddToCartError(null);
        setAddToCartQty(1);
        setSelectedVariation(event.target.value);
    };

    const handleListingLocation = () => {
        if (!!listing && !!listing.city && listing.city.name.toLowerCase() === listing.zipCode.name.toLowerCase()) {
            return <span>{listing.zipCode.name}</span>;
        } else {
            if (!!listing.city) {
                return (
                    <>
                    <span>{listing.zipCode.name}</span>
                    <span>, {listing.city.name}</span>
                    </>
                );
            } else {
                return (
                    <>
                    <span>{listing.zipCode.name}</span>
                    </>
                );
            };
        };
    };

    return (
        <DefaultLayout>
            {!!listing && <ViewListingSEO title={"Oglas " + title} url={url} quote={"Oglas " + title} />}
            <div className="bg-gray-lightest px-3">
                {/* breadcrumb */}
                <div className="container mx-auto">
                    <Breadcrumb breadcrumb={breadcrumb} listing={listing} />
                </div>
                {/* view listing columns */}
                {!!listing && (
                    <div className="container mx-auto pb-8">
                        <div className="flex flex-wrap -mx-3 overflow-none">
                            {/* listing title */}
                            {!isDesktopOrLaptop && <div className="w-full -mt-1 mb-2">
                                <h1 className="m-0 px-3 mb-3 leading-8">
                                    {!!listing.isBoosted && (
                                        <span className="whitespace-nowrap text-sm font-bold tracking-wider uppercase py-1.5 px-3 rounded-md bg-purple text-white mr-3">
                                            <FontAwesomeIcon icon={IconsLibrary.faFire} className="text-yellow text-lg mr-2" />
                                            <span>Dobra roba</span>
                                        </span>
                                    )}
                                    {!!listing.new && (
                                        <span className="whitespace-nowrap text-sm font-bold tracking-wider uppercase py-1.5 px-3 rounded-md bg-purple text-white mr-3">
                                            <FontAwesomeIcon icon={IconsLibrary.faHashtag} className="text-yellow text-lg mr-2" />
                                            <span>Novo</span>
                                        </span>
                                    )}
                                    {!!listing.type && listing.type === "RENT" && (
                                            <span className="whitespace-nowrap text-sm font-bold uppercase py-1.5 px-3 rounded-md bg-purple text-white mr-3">
                                                <FontAwesomeIcon icon={IconsLibrary.faHashtag} className="text-yellow text-lg mr-2" />
                                                <span>Iznajmljivanje</span>
                                            </span>
                                    )}

                                    {/* title */}
                                    <span className="text-2xl font-semibold text-gray-darkest" dangerouslySetInnerHTML={{ __html: listing.title }} />

                                    {/* listing location */}
                                    {!!listing.zipCode && <span className="whitespace-nowrap text-sm font-semibold text-gray-dark ml-3">
                                        <FontAwesomeIcon icon={IconsLibrary.faMapMarker} className="mr-2" />
                                        {handleListingLocation()}
                                    </span>}
                                </h1>
                            </div>}

                            {/* listing photos */}
                            <div className={"self-start px-3 w-full md:w-1/3 lg:w-2/5 xl:w-1/2 overflow-none mb-2" + (!!isDesktopOrLaptop ? " sticky top-28" : "")}>
                                <PhotoGrid listingId={listing.id} photos={listing.photos} listing={listing} />
                            </div>

                            {/* listing details */}
                            <div className="px-3 w-full md:w-2/3 lg:w-3/5 xl:w-1/2 overflow-hidden">

                                {/* listing title */}
                                {!!isDesktopOrLaptop && <div className="-mt-1 mb-2">
                                    <h1 className="m-0 p-0 leading-8">
                                        {!!listing.isBoosted && (
                                            <span className="whitespace-nowrap leading-8 font-bold tracking-wider uppercase py-1.5 px-3 rounded-md bg-purple text-white mr-3">
                                                <FontAwesomeIcon icon={IconsLibrary.faFire} className="text-yellow mr-2" />
                                                <span className="text-sm">Dobra Roba</span>
                                            </span>
                                        )}
                                        {!!listing.new && (
                                            <span className="whitespace-nowrap font-bold tracking-wider uppercase py-1.5 px-3 rounded-md bg-purple text-white mr-3">
                                                <FontAwesomeIcon icon={IconsLibrary.faHashtag} className="text-yellow mr-2" />
                                                <span className="text-sm">Novo</span>
                                            </span>
                                        )}
                                        {!!listing.type && listing.type === "RENT" && (
                                            <span className="whitespace-nowrap font-bold tracking-wider uppercase py-1.5 px-3 rounded-md bg-purple text-white mr-3">
                                                <FontAwesomeIcon icon={IconsLibrary.faHashtag} className="text-yellow mr-2" />
                                                <span className="text-sm">Iznajmljivanje</span>
                                            </span>
                                        )}

                                        {/* title */}
                                        <span className="text-2xl font-semibold text-gray-darkest" dangerouslySetInnerHTML={{ __html: listing.title }} />

                                        {/* listing location */}
                                        {!!listing.zipCode && <span className="whitespace-nowrap text-sm font-semibold text-gray-dark ml-3">
                                            <FontAwesomeIcon icon={IconsLibrary.faMapMarker} className="mr-2" />
                                            {handleListingLocation()}
                                        </span>}
                                    </h1>
                                </div>}

                                {/* listing owner details */}
                                <div className="mb-1">
                                    <ListingOwnerCard owner={listing.owner} />
                                </div>

                                {/* listing basic info */}
                                <div className="flex flex-wrap items-center justify-start -mx-1 overflow-hidden mb-4 tracking-wider">
                                    {/* listing price */}
                                    {!listing.discountActive && !listing.askForPrice && !!auth.isAuthenticated && (<div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                        <div className="p-2 rounded-md bg-purple text-white whitespace-nowrap font-bold text-sm text-center">
                                            {!listing.askForPrice && (!!listing.price || listing.price === 0) && (handlePrice(listing.price))}
                                        </div>
                                    </div>)}
                                    {!listing.discountActive && !listing.askForPrice && !auth.isAuthenticated && (<div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                    <NavLink to={`/prijava?redirectTo=/${listing.slug}/oglas/${listing.id}`} title="Prijavi se">
                                        <div className="p-2 rounded-md bg-purple text-white whitespace-nowrap font-bold text-sm text-center">
                                            {!listing.askForPrice && (!!listing.price || listing.price === 0) && (handlePrice(listing.price))}
                                        </div>
                                    </NavLink>
                                    </div>)}
                                    {(!listing.discountActive && !!listing.askForPrice) && (!auth.isAuthenticated) && (
                                    <NavLink to={`/prijava?redirectTo=/${listing.slug}/oglas/${listing.id}`} className="w-full sm:w-1/2 md:w-1/3 px-1 my-1 tracking-wider" title="Prijavi se">
                                        <div className="p-2 rounded-md bg-purple text-white whitespace-nowrap font-bold text-sm text-center">
                                            {!!listing.askForPrice && listing.askForPrice}
                                        </div>
                                    </NavLink>
                                    )}
                                    {(!listing.discountActive && !!listing.askForPrice) && (!!auth.isAuthenticated && !!auth.currentUser && listing.owner.id !== auth.currentUser.id) && (
                                    <Button type="button" className="w-full sm:w-1/2 md:w-1/3 px-1 my-1 tracking-wider" onClick={handleMessage}>
                                        <div className="p-2 rounded-md bg-purple text-white whitespace-nowrap font-bold text-sm text-center">
                                            {!!listing.askForPrice && listing.askForPrice}
                                        </div>
                                    </Button>
                                    )}
                                    {(!listing.discountActive && !!listing.askForPrice) && (!!auth.isAuthenticated && !!auth.currentUser && listing.owner.id === auth.currentUser.id) && (
                                    <div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                        <div className="p-2 rounded-md bg-purple text-white whitespace-nowrap font-bold text-sm text-center">
                                            {!!listing.askForPrice && listing.askForPrice}
                                        </div>
                                    </div>)}
                                    {!!listing.discountActive && (
                                    <>
                                        <div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                            <div className="p-2 text-red bg-white rounded-md whitespace-nowrap font-bold text-sm text-center line-through">
                                                {!listing.askForPrice && (!!listing.price || listing.price === 0) && (handlePrice(listing.originalPrice))}
                                            </div>
                                        </div>
                                        {!auth.isAuthenticated && (
                                            <NavLink to={`/prijava?redirectTo=/${listing.slug}/oglas/${listing.id}`} title="Prijavi se" className="w-full sm:w-1/2 md:w-1/3 px-1 my-1 p-2 rounded-md bg-purple text-white whitespace-nowrap font-bold text-sm text-center">
                                            <div>
                                            <div>
                                                {!listing.askForPrice && (!!listing.price || listing.price === 0) && (
                                                    <>
                                                    <FontAwesomeIcon icon={IconsLibrary.faFire} className="text-yellow mr-2" />
                                                    {handlePrice(listing.price)}
                                                    </>
                                                )}
                                                </div>
                                            </div>
                                            </NavLink>
                                        )}
                                        {!!auth.isAuthenticated && (
                                            <div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                            <div className="p-2 rounded-md bg-purple text-white whitespace-nowrap font-bold text-sm text-center">
                                                {!listing.askForPrice && (!!listing.price || listing.price === 0) && (
                                                    <>
                                                    <FontAwesomeIcon icon={IconsLibrary.faFire} className="text-yellow mr-2" />
                                                    {handlePrice(listing.price)}
                                                    </>
                                                )}
                                                </div>
                                            </div>
                                        )}
                                    </>
                                    )}
                                    {/* listing publish date */}
                                    <div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                        <div className="p-2 rounded-md bg-white text-gray-darkest whitespace-nowrap font-semibold text-sm text-center">
                                            {!!listing.dateCreated ? formatD(listing.dateCreated) : formatD(listing.published)}
                                        </div>
                                    </div>

                                    {/* listing gift tag */}
                                    {listing.type === "GIFT" && (
                                        <div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                            <div className="p-2 rounded-md bg-white text-gray-darkest whitespace-nowrap font-semibold text-sm text-center">
                                                Poklon
                                            </div>
                                        </div>
                                    )}

                                    {/* listing state */}
                                    {(listing.type === "SALE" || listing.type === "GIFT") && !!listing.state && (
                                        <div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                            <div className="p-2 rounded-md bg-white text-gray-darkest whitespace-nowrap font-semibold text-sm text-center">
                                                {translateState(listing.state)}
                                            </div>
                                        </div>
                                    )}

                                    {/* listing view count */}
                                    <div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                        <div className="p-2 rounded-md bg-white text-gray-darkest whitespace-nowrap font-semibold text-sm text-center">
                                            <FontAwesomeIcon icon={IconsLibrary.faEye} className="text-purple mr-2" />
                                            <span>{listing.views}</span>
                                        </div>
                                    </div>

                                    {!!auth.currentUser && listing.owner.id === auth.currentUser.id && (
                                        <>
                                            <div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                                <NavLink to={"/moji-oglasi/izmijeni/" + listing.id} className="block p-2 rounded-md bg-white text-gray-darkest hover:bg-gray-lighter transition whitespace-nowrap font-semibold text-sm text-center" title="Izmijeni">
                                                    <FontAwesomeIcon icon={IconsLibrary.faPen} className="text-purple mr-2" />
                                                    <span>Izmijeni</span>
                                                </NavLink>
                                            </div>
                                            <div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                                <NavLink to={"/moji-oglasi/izdvoji/" + listing.id} className="block p-2 rounded-md bg-white text-gray-darkest hover:bg-gray-lighter transition whitespace-nowrap font-semibold text-sm text-center" title="Izdvoji">
                                                    <FontAwesomeIcon icon={IconsLibrary.faStar} className="text-purple mr-2" />
                                                    <span>Izdvoji</span>
                                                </NavLink>
                                            </div>
                                            <div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                                <NavLink to={"/moji-oglasi/obnovi/" + listing.id} className="block p-2 rounded-md bg-white text-gray-darkest hover:bg-gray-lighter transition whitespace-nowrap font-semibold text-sm text-center" title="Obnavljaj">
                                                    <FontAwesomeIcon icon={IconsLibrary.faSync} className="text-purple mr-2" />
                                                    <span>Obnavljaj</span>
                                                </NavLink>
                                            </div>
                                            <div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                                <Button onClick={() => handleFinish(listing.id)} className="w-full p-2 rounded-md bg-white text-gray-darkest hover:bg-gray-lighter transition whitespace-nowrap font-semibold text-sm text-center">
                                                    {!!finishLoading && (
                                                        <FontAwesomeIcon icon={IconsLibrary.faSync} className="text-purple mr-2 animate-spin" />
                                                    )}
                                                    {!finishLoading && (
                                                        <FontAwesomeIcon icon={IconsLibrary.faTimesCircle} className="text-purple mr-2" />
                                                    )}
                                                    <span>Završi</span>
                                                </Button>
                                            </div>
                                        </>
                                    )}

                                    {!!auth.currentUser && listing.owner.id !== auth.currentUser.id && (
                                        <>
                                            {/* listing add to cart qty */}
                                            {listing.type === "SALE" && !!listing.canAddToCart && (
                                                <div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                                    <div className="flex flex-nowrap space-x-1">
                                                        {/* subtract one */}
                                                        <Button size="small" variant="primary" additionalClasses="px-3 w-1/4" onClick={decrementAddToCartQty}>
                                                            <FontAwesomeIcon icon={IconsLibrary.faMinus} />
                                                        </Button>

                                                        {/* selected qty */}
                                                        <Input value={addToCartQty} onChange={handleAddToCartQty} type="text" size="small" additionalClasses="font-semibold text-center flex-shrink w-2/4"></Input>

                                                        {/* add one */}
                                                        <Button size="small" variant="primary" additionalClasses="px-3 w-1/4" onClick={incrementAddToCartQty}>
                                                            <FontAwesomeIcon icon={IconsLibrary.faPlus} />
                                                        </Button>
                                                    </div>
                                                </div>
                                            )}

                                            {/* listing add to cart button for variations */}
                                            {(listing.type === "SALE" && !!listing.canAddToCart) && (!!listing.variations && listing.variations !== undefined) && (Array.isArray(listing.variations) && listing.variations.length !== 0) && (
                                                <div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                                    <Button
                                                        className="w-full p-2 rounded-md bg-yellow text-gray-darker hover:bg-yellow-dark hover:text-gray-darkest transition whitespace-nowrap font-semibold text-sm"
                                                        disabled={!!addToCartLoading}
                                                        onClick={() => {
                                                            if (!!userBlocked) {
                                                                notify({
                                                                    text: "Korisnik Vas je blokirao.",
                                                                    id: "user-blocked-notification-add-to-cart",
                                                                  });
                                                                  setContextStyleColor('bg-red');
                                                                return;
                                                            }
                                                            const extractVariation = listing.variations.find(v => v.id === parseInt(selectedVariation));
                                                            if (!!extractVariation && (extractVariation.quantityOnStock === undefined || extractVariation.quantityOnStock < 1)) {
                                                                setAddToCartError("Artikal nije dostupan ili količina ovog artikla kod prodavca je promijenjena.");
                                                                return;
                                                            } else {
                                                                if (!!selectedVariation) {
                                                                    setVariationAddedToCart(true);
                                                                } else {
                                                                    setVariationAddedToCart(false);
                                                                    setAddToCartError(null);
                                                                    setAddToCartLoading(false);
                                                                    setContextStyleColor('bg-red');
                                                                    notify({
                                                                        text: "Odaberite varijaciju prije dodavanja u korpu.",
                                                                        id: "cannot-add-empty-variation-to-cart",
                                                                      });
                                                                };
                                                            }
                                                        }}
                                                    >
                                                        {!addToCartLoading && (
                                                            <>
                                                                <FontAwesomeIcon className="mr-2 text-purple" icon={IconsLibrary.faCartPlus} />
                                                                <span>Dodaj u korpu</span>
                                                            </>
                                                        )}
                                                        {!!addToCartLoading && (
                                                            <>
                                                                <FontAwesomeIcon className="animate-spin mr-2" icon={IconsLibrary.faSyncAlt} />
                                                                <span>Dodaj u korpu</span>
                                                            </>
                                                        )}
                                                    </Button>
                                                </div>
                                            )}

                                            {/* listing add to cart button */}
                                            {(listing.type === "SALE" && !!listing.canAddToCart) && (!listing.variations || listing.variations === undefined) && (
                                                <div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                                    <Button
                                                        className="w-full p-2 rounded-md bg-yellow text-gray-darker hover:bg-yellow-dark hover:text-gray-darkest transition whitespace-nowrap font-semibold text-sm"
                                                        disabled={!!addToCartLoading}
                                                        onClick={() => {
                                                            if (!!userBlocked) {
                                                                notify({
                                                                    text: "Korisnik Vas je blokirao.",
                                                                    id: "user-blocked-notification-add-to-cart",
                                                                  });
                                                                  setContextStyleColor('bg-red');
                                                                return;
                                                            }
                                                            if (listing.quantityOnStock === undefined || listing.quantityOnStock < 1) {
                                                                setAddToCartError("Artikal nije dostupan ili količina ovog artikla kod prodavca je promijenjena.");
                                                                return;
                                                            } else {
                                                                setVariationAddedToCart(false);
                                                                    setAddToCartError(null);
                                                                    setAddToCartLoading(true);
                                                                    const items = [
                                                                        {
                                                                            item_id: listing.id,
                                                                            item_name: listing.title,
                                                                            currency: "BAM",
                                                                            discount: !!listing.discountActive ? listing.price : 0,
                                                                            item_brand: !!listing.brand ? listing.brand.name : "",
                                                                            item_category: !!listing.category ? listing.category.name : "",
                                                                            price: listing.price,
                                                                            quantity: addToCartQty
                                                                          }
                                                                    ];
                                                
                                                                    gaEvents.addToCartEvent(listing.price, items);
                                                                    addToCart(
                                                                        listing,
                                                                        addToCartQty,
                                                                        // callback
                                                                        () => {
                                                                            setAddToCartLoading(false);
                                                                            setAddToCartQty(1);
                                                                            if (addToCartError === null) {
                                                                                setContextStyleColor('bg-purple');
                                                                                notify({
                                                                                    text: "Oglas dodan u korpu uspješno!",
                                                                                    id: "add-to-cart-success-view-listing",
                                                                                  });
                                                                                  localStorage.setItem("cart_buyer_initiate", !!auth && !!auth.currentUser && auth.currentUser.id);
                                                                            }
                                                                        },
                                                                        // error callback
                                                                        error => { setAddToCartError(error) }
                                                                    )  
                                                                }
                                                        }}
                                                    >
                                                        {!addToCartLoading && (
                                                            <>
                                                                <FontAwesomeIcon className="mr-2 text-purple" icon={IconsLibrary.faCartPlus} />
                                                                <span>Dodaj u korpu</span>
                                                            </>
                                                        )}
                                                        {!!addToCartLoading && (
                                                            <>
                                                                <FontAwesomeIcon className="animate-spin mr-2" icon={IconsLibrary.faSyncAlt} />
                                                                <span>Dodaj u korpu</span>
                                                            </>
                                                        )}
                                                    </Button>
                                                </div>
                                            )}

                                            {/* errors display block */}
                                            {listing.type === "SALE" && !!addToCartError && (
                                                <div className="w-full px-1 my-1">
                                                    <p className="text-red-800 text-sm">{addToCartError}</p>
                                                </div>
                                            )}

                                            {/* listing grade */}
                                            {listing.type !== "JOB" && listing.type !== "GIFT" && !!listing.grade && <div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                                <Button title="Ocjene" className="w-full transition hover:bg-gray-lighter flex flex-nowrap justify-center items-center p-2 rounded-md bg-white text-gray-darkest whitespace-nowrap font-semibold text-sm text-center">
                                                    <span>Ocjena: {listing.grade}</span>
                                                    <FontAwesomeIcon icon={IconsLibrary.faStar} className="ml-1" />
                                                </Button>
                                            </div>}

                                            {(!!listing.price && !listing.canAddToCart) && (listing.type !== "GIFT" && listing.type !== "JOB") && (listing.type !== "RENT" && listing.type !== "SERVICE") && (
                                                <div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                                    <Button onClick={() => { !!createOrderRequest ? handleCreateOrderRequest() : handleCreateOrder() }} type="button" className="w-full p-2 rounded-md bg-yellow text-gray-darker hover:text-gray-darkest hover:bg-yellow-dark transition whitespace-nowrap font-semibold text-sm text-center">
                                                        <FontAwesomeIcon icon={IconsLibrary.faShoppingCart} className="text-purple mr-2" />
                                                        {!createOrderRequest && <>
                                                            {listing.type === "SALE" && <span>Kupi</span>}
                                                        </>}
                                                        {!!createOrderRequest && <span>Potvrdi kupovinu</span>}
                                                    </Button>
                                                </div>
                                            )}

                                            {/* listing contact link */}
                                            <div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                                <Button type="button" onClick={handleMessage} className="w-full p-2 rounded-md bg-white text-gray-darkest hover:bg-gray-lighter transition whitespace-nowrap font-semibold text-sm text-center">
                                                    <FontAwesomeIcon icon={IconsLibrary.faEnvelope} className="text-purple mr-2" />
                                                    <span>Privatna poruka</span>
                                                </Button>
                                            </div>

                                            {/* listing contact email */}
                                            {/* {!!auth && !!auth.isAuthenticated && !!listing.owner.email && <div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                                <a href={"mailto:" + listing.owner.email} aria-label="Kontakt email" type="button" className="block p-2 rounded-md bg-white text-gray-darkest hover:bg-gray-lighter transition whitespace-nowrap font-semibold text-sm text-center">
                                                    <FontAwesomeIcon icon={IconsLibrary.faAt} className="text-purple mr-2" />
                                                    <span>E-mail</span>
                                                </a>
                                            </div>} */}

                                            {/* listing contact phone */}
                                            {!!auth && !!auth.isAuthenticated && !!listing.owner.phone && <div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                                <Button type="button" onClick={() => setPhoneButton(listing.owner.phone)} className="w-full p-2 rounded-md bg-white text-gray-darkest hover:bg-gray-lighter transition whitespace-nowrap font-semibold text-sm text-center">
                                                    <FontAwesomeIcon icon={IconsLibrary.faPhone} className="text-purple mr-2" />
                                                    <span>{phoneButton}</span>
                                                </Button>
                                            </div>}

                                            {/* fav button */}
                                            {!!auth && !!auth.isAuthenticated && !!canFav && <div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                                <Button disabled={!!favoriteLoading} onClick={handleFavorite} type="button" className="w-full p-2 rounded-md bg-white text-gray-darkest hover:bg-gray-lighter transition whitespace-nowrap font-semibold text-sm text-center">
                                                    {!!favoriteLoading && <FontAwesomeIcon icon={IconsLibrary.faSync} className="text-purple animate-spin mr-2" />}
                                                    {!favoriteLoading && <FontAwesomeIcon icon={IconsLibrary.faHeart} className="text-purple mr-2" />}
                                                    <span>Sačuvaj</span>
                                                </Button>
                                            </div>}

                                            {!!auth && !!auth.isAuthenticated && <div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                                <Button disabled={!!reportReasonSending} onClick={handleOpenReportModal} type="button" className="w-full p-2 rounded-md bg-white text-gray-darkest hover:bg-gray-lighter transition whitespace-nowrap font-semibold text-sm text-center">
                                                    {!!reportReasonSending && <FontAwesomeIcon icon={IconsLibrary.faSync} className="text-purple animate-spin mr-2" />}
                                                    {!reportReasonSending && <FontAwesomeIcon icon={IconsLibrary.faBan} className="text-purple mr-2" />}
                                                    <span>Prijavi nepravilnost</span>
                                                </Button>
                                            </div>}

                                            {/* report button */}
                                            {/* {!!auth && !!auth.isAuthenticated && <div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                                <Button type="button" className="w-full p-2 rounded-md bg-white text-gray-darkest hover:bg-gray-lighter transition whitespace-nowrap font-semibold text-sm text-center">
                                                    <FontAwesomeIcon icon={["fas", "exclamation-circle"]} className="text-purple mr-2" />
                                                    <span>Prijavi</span>
                                                </Button>
                                            </div>} */}
                                        </>
                                    )}
                                    <div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                        <div className="p-2 rounded-md bg-white text-gray-darkest whitespace-nowrap font-semibold text-sm text-center">
                                            <FacebookShareButton url={`https://www.roba.ba${url}`} quote={"Oglas " + title} hashtag="#stiglaroba">
                                            <FontAwesomeIcon icon={IconsLibrary.fabfaFacebook} className="text-purple mr-2" />
                                            </FacebookShareButton>
                                            <TwitterShareButton url={`https://www.roba.ba${url}`} title={title} via="stiglaroba">
                                            <FontAwesomeIcon icon={IconsLibrary.fabTwitter} className="text-purple mr-2" />
                                            </TwitterShareButton>
                                            <PinterestShareButton url={`https://www.roba.ba${url}`} media={"https://www.roba.ba/i_listings/robaba-ecommerce.png"} description={"Oglas " + title}>
                                            <FontAwesomeIcon icon={IconsLibrary.fabPinterest} className="text-purple mr-2" />
                                            </PinterestShareButton>
                                        </div>
                                    </div>
                                    {/* listing contact link */}
                                    {!auth.isAuthenticated && (
                                    <div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                        <NavLink to={`/prijava?redirectTo=/${listing.slug}/oglas/${listing.id}`} title="Prijavi se">
                                            <div className="p-2 rounded-md bg-white tracking-normal text-gray-darkest hover:bg-gray-lighter transition whitespace-nowrap font-semibold text-sm text-center">
                                                <FontAwesomeIcon icon={IconsLibrary.faEnvelope} className="text-purple mr-2" />
                                                <span>Privatna poruka</span>
                                            </div>
                                        </NavLink>
                                    </div>
                                    )}
                                    {!!listing.variations && listing.variations.length !== 0 && (
                                    <div className="w-full sm:w-1/2 md:w-1/3 px-1 my-1">
                                    <div className="rounded-md text-gray-darkest whitespace-nowrap font-semibold text-sm text-center">
                                        <Select
                                            id="direction"
                                            name="direction"
                                            variant="primary"
                                            defaultOption={"-- Varijacija --"}
                                            value={selectedVariation}
                                            options={handleVariationSelectOptions()}
                                            onChange={handleVariationChange}
                                            additionalClasses="w-full"
                                        />
                                        </div>
                                    </div>
                                    )}
                                </div>

                                {/* listing description */}
                                {!!listing.description && (
                                    <div className="listing-description mb-6">
                                        <h2 className="mb-2 text-xs tracking-wider uppercase text-gray-darkest font-semibold">Osnovne informacije</h2>

                                        {!readMore && descriptionClean.length > 200 && (
                                            <div className="my-6 p-0 leading-7 tracking-wide text-gray-darkest" dangerouslySetInnerHTML={{ __html: descriptionExcerpt + "..." }} />
                                        )}

                                        {/* if no lead, show description instead */}
                                        {descriptionClean.length <= 200 && (
                                            <div className="my-6 p-0 leading-7 tracking-wide text-gray-darkest" dangerouslySetInnerHTML={{ __html: listing.description }} />
                                        )}

                                        {/* listing description text */}
                                        {(!!readMore && !!listing.description && listing.description.length > 0) && (
                                            <div className="my-6 p-0 leading-6 text-gray-darkest" dangerouslySetInnerHTML={{ __html: listing.description }} />
                                        )}

                                        {/* listing read more link */}
                                        {(!!descriptionClean && descriptionClean.length > 200) && (
                                            <div className="select-none">
                                                <span
                                                    className="text-sm text-purple cursor-pointer hover:underline font-semibold tracking-wide"
                                                    onClick={() => setReadMore(!readMore)}
                                                >
                                                    <FontAwesomeIcon icon={readMoreIcon} className="mr-2" />
                                                    {!readMore ? "Opširnije..." : "Sažetije"}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                )}
                                {!!loaded && 
                                !!listing && !!listing.locationCoordinates && !!listing.locationCoordinates.latitude && !!listing.locationCoordinates.longitude && (
                                <div className="mb-6">
                                    <MapLayoutView coordinates={listing.locationCoordinates} />
                                </div>
                                )}
                                <div className="listing-attributes mb-6">
                                    <h2 className="mb-2 text-xs tracking-wider uppercase text-gray-darkest font-semibold">Dodatne informacije</h2>

                                    <div className="flex flex-wrap items-center justify-start -mx-1 overflow-hidden w-full text-sm mb-3">
                                        <div className="w-full sm:w-1/2 px-1 my-1">
                                            <div className="flex flex-nowrap items-center justify-between py-2 px-3 rounded bg-white text-gray-darkest">
                                                <span className="font-semibold">Prihvata zamjenu:</span>
                                                <span className="font-base">{!!listing.acceptsTrade ? "Da" : "Ne"}</span>
                                            </div>
                                        </div>
                                        {!!listing.freeDelivery && (
                                            <div className="w-full sm:w-1/2 px-1 my-1">
                                                <div className="flex flex-nowrap items-center justify-between py-2 px-3 rounded bg-white text-gray-darkest">
                                                    <span className="font-semibold">Besplatna dostava:</span>
                                                    <span className="font-base">Da</span>
                                                </div>
                                            </div>
                                        )}
                                        {!!listing.quantityOnStock && (!listing.variations || listing.variations === undefined) && (
                                            <div className="w-full sm:w-1/2 px-1 my-1">
                                                <div className="flex flex-nowrap items-center justify-between py-2 px-3 rounded bg-white text-gray-darkest">
                                                    <span className="font-semibold">Količina na stanju:</span>
                                                    <span className="font-base">{listing.quantityOnStock}</span>
                                                </div>
                                            </div>
                                        )}
                                        {(!!listing.variations) && (listing.variations !== undefined && Array.isArray(listing.variations)) && (listing.variations.length !== 0 && !!selectedVariation) && (
                                            <div className="w-full sm:w-1/2 px-1 my-1">
                                                <div className="flex flex-nowrap items-center justify-between py-2 px-3 rounded bg-white text-gray-darkest">
                                                    <span className="font-semibold">Količina na stanju:</span>
                                                    <span className="font-base">{listing.variations.find(v => v.id === parseInt(selectedVariation))?.quantityOnStock}</span>
                                                </div>
                                            </div>
                                        )}
                                        {!!listing.brand && (
                                            <div className="w-full sm:w-1/2 px-1 my-1">
                                                <div className="flex flex-nowrap items-center justify-between py-2 px-3 rounded bg-white text-gray-darkest">
                                                    <span className="font-semibold">Proizvođač:</span>
                                                    <span className="font-base">{listing.brand.name}</span>
                                                </div>
                                            </div>
                                        )}
                                        {!!listing.model && (
                                            <div className="w-full sm:w-1/2 px-1 my-1">
                                                <div className="flex flex-nowrap items-center justify-between py-2 px-3 rounded bg-white text-gray-darkest">
                                                    <span className="font-semibold">Model:</span>
                                                    <span className="font-base">{listing.model.name}</span>
                                                </div>
                                            </div>
                                        )}

                                        {/* attributes grid */}
                                        {attributes.length > 0 && (
                                            <>
                                                {starredAttributes.map((attribute, index) => {
                                                    if (attribute.definition.type === "BOOLEAN" &&        
                                                    (!!attribute.value && attribute.value === "false")) {
                                                        return null;
                                                        } else if (attribute.definition.type === "BOOLEAN" &&
                                                        !attribute.value) {
                                                            return null;
                                                        } else {
                                                            return (
                                                                <div className="w-full sm:w-1/2 px-1 my-1" key={index}>
                                                                    <AttributeBox attribute={attribute} />
                                                                </div>
                                                                )
                                                        }
                                                })}

                                                {!!moreInfo && (
                                                    <>
                                                        {unstarredAttributes.map((attribute, index) => {
                                                            if (attribute.definition.type === "BOOLEAN" &&        
                                                            (!!attribute.value && attribute.value === "false")) {
                                                                return null;
                                                                } else if (attribute.definition.type === "BOOLEAN" &&
                                                                !attribute.value) {
                                                                    return null;
                                                                } else {
                                                                    return (
                                                                        <div className="w-full sm:w-1/2 px-1 my-1" key={index}>
                                                                            <AttributeBox attribute={attribute} />
                                                                        </div>
                                                                        )
                                                                }
                                                        }
                                                        )}
                                                    </>
                                                )}
                                                {unstarredAttributes.length > 0 && (
                                                    <div className="w-full pt-1">
                                                        <Button
                                                            additionalClasses="block mx-auto bg-white text-sm hover:bg-gray-lighter whitespace-nowrap"
                                                            onClick={() => setMoreInfo(!moreInfo)}
                                                        >
                                                            <FontAwesomeIcon icon={moreInfoIcon} className="mr-2" />
                                                            {!moreInfo ? "Više informacija" : "Manje informacija"}
                                                        </Button>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            {!!similarListings && similarListings.length > 0 && (
                <div className="py-4">
                    <div className="container mx-auto my-6">
                        <h2 className="px-4 text-xl font-semibold text-gray-darkest mb-3">Slični oglasi</h2>
                        <div className="flex flex-wrap overflow-hidden">
                            {similarListings.slice(0, 8).map((similarListing, index) => (
                                <ListingGridBox key={index} listing={similarListing} />
                            ))}
                        </div>
                    </div>
                </div>
            )}
            {!!currentCategory && !!newestCategory && newestCategory.length > 0 && (
                <div className="py-4">
                    <div className="container mx-auto my-6">
                        <h2 className="px-4 text-xl font-semibold text-gray-darkest mb-3">
                            <span>Najnoviji oglasi u kategoriji</span>
                            <NavLink className="mx-2 font-bold text-purple hover:underline" to={getCategoryBrowserUrl(currentCategory.id)} title={currentCategory.name}>{currentCategory.name}</NavLink>
                        </h2>
                        <div className="flex flex-wrap overflow-hidden">
                            {newestCategory.slice(0, 8).map((newestCategoryListing, index) => (
                                <ListingGridBox key={index} listing={newestCategoryListing} />
                            ))}
                        </div>
                    </div>
                </div>
            )}
            {!!newestLister && newestLister.length > 0 && (
                <div className="py-4">
                    <div className="container mx-auto my-6">
                        <h2 className="px-4 text-xl font-semibold text-gray-darkest mb-3">
                            <span>Najnoviji oglasi oglašivača</span>
                            <NavLink className="mx-2 font-bold text-purple hover:underline" to={"/profil/" + listing.owner.login} title={!!listing.owner.companyAccount ? listing.owner.companyName : listing.owner.login}>{!!listing.owner.companyAccount ? listing.owner.companyName : listing.owner.login}</NavLink>
                        </h2>
                        <div className="flex flex-wrap overflow-hidden">
                            {newestLister.slice(0, 8).map((newestCategoryListing, index) => (
                                <ListingGridBox key={index} listing={newestCategoryListing} />
                            ))}
                        </div>
                    </div>
                </div>
            )}
            {showReportModal ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none text-gray-darkest"
                    >
                        <div className="relative w-80 sm:w-96 md:w-full lg:w-full my-6 mx-auto max-w-2xl">
                            {/*content*/}
                            <div className="border-0 rounded-lg border-3 border-purple relative flex flex-col w-full bg-gray-lightest outline-none focus:outline-none">
                                {/*header*/}
                                <div className="flex items-start justify-between p-3 border-b border-solid border-gray rounded-t">
                                    <h3 className="text-2xl py-1 font-semibold">
                                        Prijavite oglas
                                    </h3>
                                    <Button size="xs" additionalClasses="text-2xl" onClick={handleDiscardReport} >
                                        <FontAwesomeIcon icon={IconsLibrary.faTimes} />
                                    </Button>
                                </div>
                                {/*body*/}
                                <div className="relative p-3 flex-auto">
                                    {!!reportReasonSendingError && <div className="my-2 text-red text-sm">{reportReasonSendingError}</div>}
                                    <div className="w-full p-2">
                                        <Label htmlFor="report-reason" additionalClasses="text-sm">Objašnjenje</Label>
                                        {reportReasonValidationErrors.filter(err => err.field === "report-reason").map((err, index) => (
                                            <FieldError message={err.message} key={index} />
                                        ))}
                                        <Textarea
                                            id="report-reason"
                                            variant="primary"
                                            minRows={4}
                                            maxRows={10}
                                            maxLength={500}
                                            value={reportReasonMessage}
                                            onChange={event => setReportReasonMessage(event.target.value)}
                                        />
                                    </div>
                                </div>
                                {!!reportReasonSentSuccess && (
                                 <div className="relative flex-auto">
                                  <p className="my-4 text-sm text-center">
                                    Vaša prijava je uspješno poslata!
                                  </p>
                                </div>
                                )}
                                {/*footer*/}
                                {!reportReasonSentSuccess && (
                                <div className="flex items-center justify-end p-3 border-t border-solid border-gray rounded-b">
                                    <Button variant="secondary" additionalClasses="mr-3" onClick={handleDiscardReport} >
                                        <FontAwesomeIcon icon={IconsLibrary.faTimes} className="mr-2" />
                                        <span>Zatvori</span>
                                    </Button>
                                    <Button disabled={reportReasonSending} variant="primary" onClick={handleSendReport} >
                                        {!reportReasonSending && <FontAwesomeIcon icon={IconsLibrary.faPaperPlane} className="mr-2" />}
                                        {!!reportReasonSending && <FontAwesomeIcon icon={IconsLibrary.faSyncAlt} className="animate-spin mr-1" />}
                                        <span>Pošalji</span>
                                    </Button>
                                </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}

        </DefaultLayout>
    );
}

export default ViewListing;